export default __webpack_public_path__ + "static/fefa128d-8eb9-48e9-adf7-568b92a2e991-c56584a03646aef63d3515b0025948d6.woff2";